import {
  EXPORT_FILE_REQUEST,
  EXPORT_FILE_SUCCESS,
  EXPORT_FILE_ERROR,
  SEND_REPORT_REQUEST,
  SEND_REPORT_SUCCESS,
  SEND_REPORT_ERROR,
  SET_DELIVERED_REQUEST,
  SET_DELIVERED_ERROR,
  SET_DELIVERED_SUCCESS
} from '../../action/exportActions/constants';

const initialState = {
  success: false,
  isLoading: false,
  hasError: false,
  files: null,
  reportStatus: null
};

export const exportFile = (state = initialState, action) => {
  const { type, filesData, reportStatus } = action;
  switch (type) {
    case EXPORT_FILE_REQUEST:
      return {
        ...state,
        hasError: false,
        isLoading: true
      };
    case EXPORT_FILE_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        success: true,
        files: filesData
      };
    case EXPORT_FILE_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        success: false
      };

    case SEND_REPORT_REQUEST:
      return {
        ...state,
        hasError: false,
        isLoading: true
      };

    case SEND_REPORT_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        success: false
      };

    case SEND_REPORT_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        success: true,
        reportStatus: reportStatus
      };

    case SET_DELIVERED_REQUEST:
      return {
        ...state,
        hasError: false,
        isLoading: true
      };

    case SET_DELIVERED_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        success: false
      };

    case SET_DELIVERED_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        success: true
      };
    default:
      return state;
  }
};
